@if ($commonContainer | async; as commonContainer) {
  <div [ngStyle]="{ minHeight: commonContainer?.sliderMinHeight + 'px' }" class="c-margin-bottom img-slider">
    @if (((commonContainer?.component | b2bDynamicLoaderPipe: commonContainer?.key) | async); as component; ) {
      <ng-container *ngComponentOutlet="component; inputs: {
        compData: {
            containerItem: commonContainer,
            container: commonContainer,
        }
      }"/>
    }
  </div>
}
